import { robotoRegular, maximumYellow500 } from '@habitech/shared';

interface LoteIdWarningProps {
  loteId?: string | null;
  inline?: boolean;
}

export const LoteIdWarning = ({ loteId, inline = false }: LoteIdWarningProps) => {
  if (loteId) return null;

  return (
    <div
      style={{
        marginTop: inline ? 0 : '8px',
        padding: '6px 10px',
        borderRadius: '4px',
        backgroundColor: '#fffbe6',
        border: `1px solid ${maximumYellow500}`,
      }}
    >
      <p
        style={{
          fontFamily: robotoRegular,
          fontSize: '12px',
          color: '#7a5c00',
          margin: 0,
        }}
      >
        ⚠️ Este NID no tiene lote_id asignado
      </p>
    </div>
  );
};
